import type { ProductStatusType } from '@/common/types/product-status.type';

interface PerisanProductStatusType {
  persianProductStatus: Record<ProductStatusType, string | null>;
}

export const perisanProductStatusConstant: PerisanProductStatusType['persianProductStatus'] =
  {
    PRODUCTPENDING: 'در حال برسی',
    ARCHIVED: 'آرشیو شده',
    OUTOFSTOCK: 'ناموجود',
    NOTAPPROVED: 'رد شده',
    APPROVED: null,
  };
